export const start = {
	header: {
		pl: 'Moje Fizjo+'
	},
	text: {
		pl: 'Twoja doraźna pomoc w\xa0walce z\xa0dolegliwościami bólowymi kręgosłupa, barku i\xa0biodra. Pobierz aplikację, ułóż plan ćwiczeń i\xa0realizuj go w\xa0domowym zaciszu.'
	}
};
